import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import { Routes, Route } from "react-router-dom"
import HomePage from "./pages/HomePage";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Policy from "./pages/Policy";
import Pagenotfound from "./pages/Pagenotfound";
import Register from "./pages/auth/Register";
import Login from "./pages/auth/Login";
import AddFabric from "./pages/fabric/AddFabric";
import FabricListing from "./pages/fabric/FabricListing";
import UpdateFabric from "./pages/fabric/UpdateFabric";
import Fabricims from "./pages/fabric/Fabricims";
import PrivateRoute from "./components/Routes/Private";
import AddCategory from "./pages/category/AddCategory";
import CategoryList from "./pages/category/CategoryList";
import UpdateCategory from "./pages/category/UpdateCategory";
import Addpo from "./pages/purchaseorder/Addpo";
import ImageCompress from "./pages/fabric/ImageCompress";
import Polisting from "./pages/purchaseorder/Polisting";
import Editpo from "./pages/purchaseorder/Editpo";
import InwardPo from "./pages/purchaseorder/InwardPo";
import InwardPoList from "./pages/purchaseorder/InwardPoList";
import AllinwardPoList from './pages/purchaseorder/AllinwardPoList';
import ThanTransferFromWarehouse from './pages/fabric/ThanTransferFromWarehouse';
import IntransitThanList from './pages/purchaseorder/IntransitThanList';
import AddFabricOpeningBalance from './pages/fabric/AddFabricOpeningBalance';
import EditFabricOpeningBalance from './pages/fabric/EditFabricOpeningBalance';
import ItemFabricListing from './pages/fabric/ItemFabricListing';
import ItemListingForFabric from './pages/fabric/ItemListingForFabric';
import AddDupattaKali from './pages/dupattaKali/AddDupattaKali';
import DupattaKaliList from './pages/dupattaKali/DupattaKaliList';
import EditDupattaKali from './pages/dupattaKali/EditDupattaKali';
import AddpoElements from './pages/dupattaKali/po/AddpoElements';
import ElementPolisting from './pages/dupattaKali/po/ElementPolisting';
import EditpoElements from './pages/dupattaKali/po/EditpoElements';
import InwardPoElement from './pages/dupattaKali/po/InwardPoElement';
import InwardPoElementList from './pages/dupattaKali/po/InwardPoElementList';
import FabricRecoverList from './pages/fabric/FabricRecoverList';
const queryClient = new QueryClient();

function App() {
  return (
      <QueryClientProvider client={queryClient}>
            <Routes>
              <Route path="/" element={<HomePage/>}/>

              <Route path="/dashboard" element={<PrivateRoute/>}>
                <Route path="add-fabric" element={<AddFabric/>} />
                <Route path="fabric-list" element={<FabricListing/>} />
                <Route path="fabric-recover-list" element={<FabricRecoverList/>} />
                <Route path="fabric-ims" element={<Fabricims/>}/>
                <Route path="update-fabric/:fid" element={<UpdateFabric/>} />
                <Route path="add-fabric-opening-balance/:fid" element={<AddFabricOpeningBalance/>} />
                <Route path="edit-fabric-opening-balance/:fid" element={<EditFabricOpeningBalance/>} />
                <Route path="add-category" element={<AddCategory/>} />
                <Route path="category-list" element={<CategoryList/>} />
                <Route path="update-category/:id" element={<UpdateCategory/>}/>
                <Route path="add-po" element={<Addpo/>}/>
                <Route path="po-list" element={<Polisting/>}/>
                <Route path="po-edit/:po_id" element={<Editpo/>}/>
                <Route path="po-inward" element={<InwardPo/>} />
                <Route path="po-inward-list" element={<InwardPoList/>} />
                <Route path="all-po-inward-list" element={<AllinwardPoList/>} />
                <Route path="intransit-than-list" element={<IntransitThanList/>} />
                <Route path="than-transfer-from-warehouse" element={<ThanTransferFromWarehouse/>} />
                <Route path="image-compress" element={<ImageCompress/>}/>
                <Route path="item-listing" element={<ItemFabricListing/>} />
                <Route path="item-listing-for-fabric/:fb_id?" element={<ItemListingForFabric/>} />
                <Route path="add-dupatta-kali" element={<AddDupattaKali/>} />
                <Route path="dupatta-kali-list" element={<DupattaKaliList/>} />
                <Route path="edit-dupatta-kali/:id" element={<EditDupattaKali/>} />
               {/* for Elements po */}
                <Route path="add-po-elements" element={<AddpoElements/>} />
                <Route path="elements-po-listing" element={<ElementPolisting/>} />
                <Route path="elements-po-edit/:po_id" element={<EditpoElements/>} />

                 <Route path="po-element-inward" element={<InwardPoElement/>} />
                  <Route path="po-inward-element-list" element={<InwardPoElementList/>} />
              </Route>
                
            
              <Route path="/about" element={<About/>} />
              <Route path="/contact" element={<Contact/>} />
              <Route path="/policy" element={<Policy/>} />
              <Route path="/register" element={<Register/>} />
              <Route path="/login" element={<Login/>} />
              <Route path="*" element={<Pagenotfound/>} />
            </Routes>
      </QueryClientProvider>
  );
}

export default App;
